import { render } from "./PedidosAdministradorComponent.vue?vue&type=template&id=6457c304&scoped=true"
import script from "./PedidosAdministradorComponent.vue?vue&type=script&lang=js"
export * from "./PedidosAdministradorComponent.vue?vue&type=script&lang=js"

import "./PedidosAdministradorComponent.vue?vue&type=style&index=0&id=6457c304&scoped=true&lang=css"

import exportComponent from "/Users/luismanuel/Documents/www/adminmkthl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6457c304"]])

export default __exports__